import * as React from 'react';
import { useTranslation } from 'react-i18next';
import UnauthorizedAccess from '../common/UnauthorizedAccess';

const AccessDenied = () => {
  const { t } = useTranslation();
  return (
    <UnauthorizedAccess
      fullScreen
      title={t('access_denied')}
      subTitle={t('ip_address_not_permitted')}
    />
  );
};

export default AccessDenied;
